import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, fromEvent, merge, interval, timer, Subscription } from 'rxjs';
import { debounce, map, takeWhile } from 'rxjs/operators';
import { MatDialog, MatDialogModule } from '@aw-hospital/aw-components-lib/src/material/dialog';
import log from 'loglevel';
import * as i1 from '@angular/material/dialog';
import { AwButtonModule } from '@aw-hospital/aw-components-lib/aw-button';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@aw-hospital/aw-components-lib/src/material/dialog';
import * as ɵngcc2 from '@aw-hospital/aw-components-lib/aw-button';
class TimeoutWidgetService {
    constructor(matDialog) {
        this.matDialog = matDialog;
        //Properties used to save last user event date, and last validation date
        this.lastEvent = new Date();
        this.lastCheck = new Date();
        this.intervalTime = undefined;
        this.subscriptionArray = [];
        this.exitUrl = undefined;
        this.validationTimeObservable = undefined;
        //Grace period properties
        this.initialGracePeriodTime = 60;
        this.gracePeriodTime = new BehaviorSubject(this.initialGracePeriodTime);
    }
    //Captures most recent user event and saves it as a timestamp to compare later on
    captureUserMovements() {
        const eventList = [
            'click',
            'scroll',
            'wheel',
            'touchmove',
            'touchend',
            'keyup',
            'mousemove'
        ];
        const auxEventArray = eventList.map(e => fromEvent(document, e));
        return merge(...auxEventArray).pipe(debounce(() => interval(500)), map(() => {
            this.lastEvent = new Date();
        }));
    }
    //Uses an interval set by the parent  
    intervalValidation() {
        return this.validationTimeObservable.pipe(map(() => {
            if (this.lastCheck.getTime() >= this.lastEvent.getTime()) {
                this.newModalInstance();
                this.unsubscribeFromAll();
            }
            this.lastCheck = new Date();
        }));
    }
    gracePeriodInterval() {
        return timer(0, 1000).pipe(map(() => {
            this.gracePeriodTime.next(this.gracePeriodTime.getValue() - 1);
            return this.gracePeriodTime.getValue();
        }), takeWhile(value => value >= 0));
    }
    //This method is called by the parent component to initialize the timed validation and capture user events
    //it returns an observable that so that the parent knows when to accept the timeout alert modal
    initializeTimeoutService(receivedTime, receivedExitUrl) {
        this.intervalTime = receivedTime;
        this.exitUrl = receivedExitUrl;
        this.validationTimeObservable = interval((1000 * 60) * receivedTime);
        const captureMovSub = this.captureUserMovements().subscribe();
        const intervalSub = this.intervalValidation().subscribe();
        this.subscriptionArray.push(captureMovSub);
        this.subscriptionArray.push(intervalSub);
        log.info(`Start timout subscription for  ${this.exitUrl} and ${this.validationTimeObservable}`);
    }
    //Returns a component factory with the modal component attached so the parent component can create/destroy it
    //when necessary
    newModalInstance() {
        this.dialogRef = this.matDialog.open(TimeoutModalComponent, {
            panelClass: ['aw-modal', 'modal-sm', 'adaptive-dialog', 'adaptive-sm-type-d'],
            backdropClass: 'blured',
            ariaLabelledBy: 'modalHeading',
            ariaDescribedBy: 'modalContent',
            disableClose: true
        });
    }
    //This method is used to restart all verifications on parent component.
    //it does not return anything since the showTimeoutModal observable has already been subscribed in the init method
    restartTimeoutSubscriptions() {
        this.subscriptionArray = [];
        this.gracePeriodTime = new BehaviorSubject(this.initialGracePeriodTime);
        this.initializeTimeoutService(this.intervalTime, this.exitUrl);
        log.info(`Reset timout subscription for  ${this.exitUrl} and duration of ${this.intervalTime}`);
        this.dialogRef.close();
    }
    redirectToExitUrl() {
        log.info(`User is about to be redirected to the exit url ${this.exitUrl}`);
        window.location.href = this.exitUrl;
    }
    //it's public so that the parent component can call it on his OnDestroy
    unsubscribeFromAll() {
        this.subscriptionArray.forEach(el => {
            el.unsubscribe();
        });
    }
}
TimeoutWidgetService.ɵfac = function TimeoutWidgetService_Factory(t) { return new (t || TimeoutWidgetService)(ɵngcc0.ɵɵinject(ɵngcc1.MatDialog)); };
TimeoutWidgetService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TimeoutWidgetService_Factory() { return new TimeoutWidgetService(i0.ɵɵinject(i1.MatDialog)); }, token: TimeoutWidgetService, providedIn: "root" });
TimeoutWidgetService.ctorParameters = () => [
    { type: MatDialog }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeoutWidgetService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.MatDialog }]; }, null); })();

class TimeoutModalComponent {
    constructor(timeoutWidgetService) {
        this.timeoutWidgetService = timeoutWidgetService;
        this.gracePeriodTimeSubscription = new Subscription();
    }
    ngOnInit() {
        this.gracePeriodTimeSubscription = this.timeoutWidgetService.gracePeriodInterval()
            .subscribe((res) => {
            this.timeLeft = res;
            if (res === 0) {
                this.timeoutWidgetService.redirectToExitUrl();
            }
        });
    }
    ngOnDestroy() {
        this.gracePeriodTimeSubscription.unsubscribe();
    }
    closeTimeoutModal() {
        this.timeoutWidgetService.restartTimeoutSubscriptions();
    }
}
TimeoutModalComponent.ɵfac = function TimeoutModalComponent_Factory(t) { return new (t || TimeoutModalComponent)(ɵngcc0.ɵɵdirectiveInject(TimeoutWidgetService)); };
TimeoutModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeoutModalComponent, selectors: [["app-timeout-modal"]], decls: 12, vars: 2, consts: [[1, "modal-content-wrapper"], [1, "modal-heading", "no-border"], ["id", "modalHeader"], ["aria-label", "Dismiss", "styleClasses", "mat-dialog-close icon-link gray-mid-text", 3, "click"], [1, "material-icons"], ["id", "modalContent", 1, "modal-content"], [1, "flex-column", "m-2", "m-b4", "theme-light"], ["styleClasses", "btn btn-fullwidth btn-large", 3, "click"]], template: function TimeoutModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h4", 2);
        ɵngcc0.ɵɵtext(3, "You're about to be logged out!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "aw-button", 3);
        ɵngcc0.ɵɵlistener("click", function TimeoutModalComponent_Template_aw_button_click_4_listener() { return ctx.closeTimeoutModal(); });
        ɵngcc0.ɵɵelementStart(5, "em", 4);
        ɵngcc0.ɵɵtext(6, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "aw-button", 7);
        ɵngcc0.ɵɵlistener("click", function TimeoutModalComponent_Template_aw_button_click_10_listener() { return ctx.closeTimeoutModal(); });
        ɵngcc0.ɵɵtext(11, " I'm Here ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate2(" If you remain inactive for another ", ctx.timeLeft, " ", ctx.timeLeft == 1 ? "second" : "seconds", " you'll be automatically logged out. ");
    } }, directives: [ɵngcc2.AwButtonComponent], encapsulation: 2 });
TimeoutModalComponent.ctorParameters = () => [
    { type: TimeoutWidgetService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeoutModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-timeout-modal',
                template: "<div class=\"modal-content-wrapper\">\n    <div class=\"modal-heading no-border\">\n        <h4 id=\"modalHeader\">You're about to be logged out!</h4>\n    </div>\n    <aw-button\n        aria-label=\"Dismiss\"\n        styleClasses=\"mat-dialog-close icon-link gray-mid-text\"\n        (click)=\"closeTimeoutModal()\"\n    >\n        <em class=\"material-icons\">close</em>\n    </aw-button>\n    <div class=\"modal-content\" id=\"modalContent\">\n        If you remain inactive for another {{timeLeft}} {{timeLeft == 1 ? 'second' : 'seconds'}}\n        you'll be automatically logged out.\n    </div>\n    <div class=\"flex-column m-2 m-b4 theme-light\">\n        <aw-button styleClasses=\"btn btn-fullwidth btn-large\" (click)=\"closeTimeoutModal()\">\n            I'm Here\n        </aw-button>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: TimeoutWidgetService }]; }, null); })();

class TimeoutWidgetModule {
}
TimeoutWidgetModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TimeoutWidgetModule });
TimeoutWidgetModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TimeoutWidgetModule_Factory(t) { return new (t || TimeoutWidgetModule)(); }, providers: [
        TimeoutWidgetService,
        MatDialog,
    ], imports: [[
            CommonModule,
            BrowserAnimationsModule,
            AwButtonModule,
            MatDialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TimeoutWidgetModule, { declarations: function () { return [TimeoutModalComponent]; }, imports: function () { return [CommonModule,
        BrowserAnimationsModule,
        AwButtonModule,
        MatDialogModule]; }, exports: function () { return [TimeoutModalComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeoutWidgetModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TimeoutModalComponent,
                ],
                imports: [
                    CommonModule,
                    BrowserAnimationsModule,
                    AwButtonModule,
                    MatDialogModule
                ],
                providers: [
                    TimeoutWidgetService,
                    MatDialog,
                ],
                exports: [
                    TimeoutModalComponent,
                ]
            }]
    }], null, null); })();

/*
 * American Well App Framework
 *
 * Copyright (c) 2021 American Well Systems
 * All rights reserved.
 *
 * It is illegal to use, reproduce or distribute
 * any part of this Intellectual Property without
 * prior written authorization from American Well.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TimeoutWidgetModule, TimeoutWidgetService, TimeoutModalComponent as ɵa };

//# sourceMappingURL=aw-timeout-widget.js.map